import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { MatBadgeModule } from '@angular/material/badge';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatTooltipModule } from '@angular/material/tooltip';
import { AvatarModule } from 'primeng/avatar';
import { ButtonModule } from 'primeng/button';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { DynamicDialogModule } from 'primeng/dynamicdialog';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { ToastModule } from 'primeng/toast';
import { TranslateDirective, TranslatePipe } from '@ngx-translate/core';

import { HomeComponent } from '../home/home.component';
import { HomeNotificationSettingsDialogComponent } from '../home/home-notification-settings-dialog/home-notification-settings-dialog.component';
import { HomeNotificationsDialogComponent } from '../home/home-notifications-dialog/home-notifications-dialog.component';
import { HomeSpecialOrderNotificationsDialogComponent } from '../home/home-special-order-notifications-dialog/home-special-order-notifications-dialog.component';
import { HomeUserAvatarDialogComponent } from '../home/home-user-avatar-dialog/home-user-avatar-dialog.component';
import { HomeUserToolComponent } from '../home/home-user-tool/home-user-tool.component';
import { LanguageToggleComponent } from './i18n/language-toggle.component';
import { LazyShellOverlaysComponent } from '../shell/lazy-shell-overlays.component';
import { NavigationIntentPreloadDirective } from './routing/navigation-intent-preload.directive';
import { UserProfileModule } from './overlays/user-profile-dialog/user-profile.module';

@NgModule({
  declarations: [
    HomeComponent,
    HomeUserToolComponent,
    HomeUserAvatarDialogComponent,
    HomeNotificationSettingsDialogComponent,
    HomeNotificationsDialogComponent,
    HomeSpecialOrderNotificationsDialogComponent,
    LazyShellOverlaysComponent,
  ],
  imports: [
    CommonModule,
    RouterModule,    MatBadgeModule,
    MatButtonModule,
    MatIconModule,
    MatSidenavModule,
    MatSlideToggleModule,
    MatTooltipModule,
    AvatarModule,
    ButtonModule,
    ConfirmDialogModule,
    DynamicDialogModule,
    ProgressSpinnerModule,
    ToastModule,
    LanguageToggleComponent,
    TranslateDirective,
    TranslatePipe,
    NavigationIntentPreloadDirective,
    UserProfileModule,
  ],
  exports: [
    HomeComponent,
    HomeUserToolComponent,
    HomeUserAvatarDialogComponent,
    HomeNotificationSettingsDialogComponent,
    HomeNotificationsDialogComponent,
    HomeSpecialOrderNotificationsDialogComponent,
    LazyShellOverlaysComponent,
  ],
})
export class ShellModule {}
